<template>
	<div>
		<div class="main_horn_fadein" v-show="showWordInfo">
			<div class="box">
				<audio :src="audioPath" v-if="shows" style="opacity: 0;position: absolute;" ref="audioPlayer" controls="controls"></audio>
				<div class="head">
					<img src="@/assets/images/close_03.png" @click="close" class="close" />
					<p>{{wordInfo.word}}</p>
					<div class="speek">
						<div @click="play('UK')">
							<span>UK /</span>
							<img src="@/assets/images/horn_03.png" />
						</div>
						<div @click="play('US')">
							<span>US /</span>
							<img src="@/assets/images/horn_03.png" />
						</div>
					</div>
				</div>
				<div class="children">
					<div class="item">
						<p class="tit">{{$t('cidianshiyi')}}</p>
						<span class="desc" v-html="wordInfo.translation"></span>
					</div>
					<div class="button">
						<div class="on" @click="close">{{$t('back')}}<</div>
						<div @click="join">{{$t('joindcb')}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import protal from "@/api/protal";
	import { Message } from 'element-ui';
	import { Loading } from 'element-ui';
	export default {
		name: 'showWordInfo',
		props: ['wordInfo'],
		data() {
			return {
				audioPath: '',
				shows: true
			}
		},
		computed: {
			showWordInfo() {

				return this.$store.state.showWordInfo;
			}
		},
		mounted() {
			
		},
		methods: {
			join() {
				protal.addMyWordBook({
					word: this.wordInfo.word
				}).then(res => {
					if(res.code == 200) {
						this.$message({
							message:  this.$t('submitsuccess'),
							type: 'success',
							duration: 700
						});
					}
					this.loading.close();
				})
			},
			close() {
				this.$store.commit("showWordInfo", false);
				const audioPlayer = this.$refs.audioPlayer;
				audioPlayer.pause();
			},
			play(type) {
				if(type == 'UK') {
					this.audioPath = this.wordInfo.audioAm
				} else {
					this.audioPath = this.wordInfo.audioEm
				}
				setTimeout(()=>{
					const audioPlayer = this.$refs.audioPlayer;
					audioPlayer.play();
				},300)
			}
		},
	}
</script>

<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/components/showWordInfo.vue